module.exports = __webpack_public_path__ + "img/sber.567ff411.svg";